export const useMobileNavActions = () => {
    const toggleOffcanvas = (requestedStatus: boolean) => {
        const target = document.querySelector(".mobile-offcanvas") as HTMLDivElement
        document.body.style.overflow = requestedStatus ? "hidden" : "auto";
        target.classList.toggle("hidden");
    }
    return {toggleOffcanvas}
}